module.exports = __webpack_public_path__ + "img/welcome.56393b68.svg";